if (!customElements.get('td-featured-testimonial')) {
  class TDFeaturedTestimonial extends HTMLElement {
    static SELECTORS = {
      slider: '[data-td-featured-testimonial-slider]',
      slide: '[data-td-featured-testimonial-slide]',
      viewport: '[data-td-embla-viewport]',
    };

    constructor() {
      super();
      this.emblaApi = null;
      this.handleEmblaInit = this.handleEmblaInit.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.sliderElement = this.querySelector(TDFeaturedTestimonial.SELECTORS.slider);
      this.slideElements = Array.from(this.querySelectorAll(TDFeaturedTestimonial.SELECTORS.slide));
      this.viewportElement = this.querySelector(TDFeaturedTestimonial.SELECTORS.viewport);

      if (!(this.sliderElement instanceof HTMLElement)) {
        return;
      }

      this.sliderElement.addEventListener('embla:init', this.handleEmblaInit);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      window.addEventListener('resize', this.handleResize, { passive: true });

      if (this.sliderElement.emblaApi) {
        this.emblaApi = this.sliderElement.emblaApi;
      }

      this.updateSliderState();
    }

    disconnectedCallback() {
      this.sliderElement?.removeEventListener('embla:init', this.handleEmblaInit);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      window.removeEventListener('resize', this.handleResize);
      this.emblaApi = null;
    }

    handleEmblaInit(event) {
      this.emblaApi = event?.detail?.api || this.sliderElement?.emblaApi || null;
      this.updateSliderState();
    }

    handleResize() {
      this.emblaApi?.reInit();
      this.updateSliderState();
    }

    updateSliderState() {
      if (!(this.viewportElement instanceof HTMLElement)) {
        return;
      }

      const hasOverflow = this.viewportElement.scrollWidth - this.viewportElement.clientWidth > 1;
      this.dataset.tdSliderOverflow = hasOverflow ? 'true' : 'false';
    }

    handleBlockSelect(event) {
      const blockId = event.detail?.blockId;
      const slide = this.getSlideByBlockId(blockId);
      if (!(slide instanceof HTMLElement) || !this.emblaApi) {
        return;
      }

      const slideIndex = this.slideElements.indexOf(slide);
      if (slideIndex >= 0) {
        this.emblaApi.scrollTo(slideIndex, true);
      }
    }

    getSlideByBlockId(blockId) {
      if (!blockId) {
        return null;
      }

      const escapedBlockId = typeof CSS !== 'undefined' && typeof CSS.escape === 'function' ? CSS.escape(blockId) : blockId;
      return this.querySelector(`[data-td-block-id="${escapedBlockId}"]`);
    }
  }

  customElements.define('td-featured-testimonial', TDFeaturedTestimonial);
}
